export default __webpack_public_path__ + "static/media/6.dd5ff933.jpg";